module.exports = __webpack_public_path__ + "static/media/espectometro.91a82200.png";